export default __webpack_public_path__ + "static/media/close.93c170cc.svg";